/**
 * get the property type from the property URI
 * @param propTypeUri
 * @returns string
 */
export default function getPropType(propTypeUri = ''): string {
  let type;
  try {
    type = propTypeUri.substring(propTypeUri.lastIndexOf('#') + 1, propTypeUri.length);
  } catch (e) {
    type = 'error';
    console.warn('---> Error getting property type', propTypeUri);
    console.error(e);
  }
  return type;
}
